:host {
  display: block;
}
.grid-header{
  margin-bottom: 60px;
}